import RestUtil from "../util/RestUtil";
import {Charges, EquityMarket, OptionsMapping, Pair} from "../models/SGB";
import Logger from "../util/Logger";
import {AppProperties} from "../models/AppProperties";
import {SellOrder} from "../models/SellOrder";
import {Feed} from "../models/Feed";
import {Exchange} from "../models/Exchange";
import {DeepCombo} from "../models/DeepCombo";
import {Position} from "../models/Position";
import {TradeBook} from "../models/TradeBook";
import {SqueezeSell} from "../models/Squeeze";
import {ClosingPrice} from "../models/ClosingPrice";
import {FuturePositions} from "../models/PositionAnalyses";
import {Info} from "./Info";
import {OptionStatus} from "../models/OptionStatus";
import {PlacedCombo} from "../models/PlacedCombo";
import {AppClients} from "../models/AppClients";
import {ClientBalance} from "../models/ClientMargin";
import {ChainPositions} from "../models/ChainPositions";
import {ClientCombo} from "../models/ClientCombo";
import {GenInfo} from "../models/GenInfo";
import {SGBMarket} from "../models/SGBMarket";
import {Combo} from "../models/Combo";
import { ContractNote } from "../models/ContractNote";
import {Bond} from "../models/Bond";
import {ContractPosition} from "../models/ContractPosition";
import {Closing} from "../models/Closing";
import {McxDevolvementResult} from "../models/McxDevolvement";
import Config from "../Config";
import {FCStatus} from "../models/FCStatus";
import {ComboOrder, TodayTrades} from "../models/TodayTrades";
import {ReportResponse} from "../models/ReportResponse";
import {ReportUploadResponse} from "../models/ReportUploadResponse";
import {ClientReportRange} from "../models/ClientReportRange";
import {RealizedReportDetailRow, RealizedReportRow} from "../models/RealizedReport";

export type Client = {
    user_id:string,
    ignore:boolean,
}
export type BRS = {
    brs:boolean,
}

export interface DailyAnalyses {
    analyses: Analyses,
    date: string,

}
interface Analyses {
    profitByRules: number,
    gramsExchanges: number,// to ensur
    profitByExchange: number,
    monthsEarned: number,
    investedGrams: number,
    investedAtPrice: number,
    timeToRedemptionMonths: number,
    goldPriceThen: number,
    goldPriceNow: number,
}

class GatewayService{
    async login(clientId:string, token:string){
        let ans = await RestUtil.get(`/init/${clientId}/${token}`);
        return ans;
    }

    analyse(from: string, to: string, clientId: string, group: boolean){
        return RestUtil.get<Array<DailyAnalyses>>(`/analyse/${from}/${to}/${clientId}/${group}`)
    }

    feed(tradingsymbol:string, days:number){
        return RestUtil.get<Array<Feed>>(`/feed/${tradingsymbol}/${days}`)
    }

    getOpportunityPNC(name:string, withoutMargin:boolean){
        return RestUtil.get<Array<Combo>>(`/options/opp_all?name=${name}&isWithoutMargin=${withoutMargin}`)
        // return RestUtil.get<Array<Combo>>(`/options/opportunity3?name=${name}`)
    }

    getOpportunityOptimized(name:string, withoutMargin:boolean, buyExpiry:number, noBrain:boolean, clientId:string){
        if(buyExpiry!==-1) return RestUtil.get<Array<Combo>>(`/options/opp_optimised/${clientId}?name=${name}&isWithoutMargin=${withoutMargin}&expiry=${buyExpiry}&noBrain=${noBrain}`)
        return RestUtil.get<Array<Combo>>(`/options/opp_optimised/${clientId}?name=${name}&isWithoutMargin=${withoutMargin}&noBrain=${noBrain}`)
    }

    async getOpportunityForExpiry() {
        return await RestUtil.get<Array<Combo>>(`/options/expiry/combo`)
    }

    async getOpportunityForFutureSqOff(clientId:string):Promise<Array<Combo>> {
        return await RestUtil.get<Array<Combo>>(`/options/sqOff/futures/${clientId}`)
    }

    async getPositions(clientId: string, considerDay:boolean) {
        return (await RestUtil.get<Array<ChainPositions>>(`/options/positions${considerDay?"/day":""}/${clientId}`))

    }

    async getRawPositions(clientId: string) {
            return (await RestUtil.get<Array<Position>>(`/options/positions/raw/${clientId}`))
    }

    async getTrades(isin: string, onlyHoldings: boolean) {
        if(onlyHoldings){
            return (await RestUtil.get<Array<TradeBook>>(`/report/holding/${isin}`))
        }else{
            return (await RestUtil.get<Array<TradeBook>>(`/report/trades/${isin}`))
        }

    }

    async getRealizedReport(from: string, to: string, clientId: string) {
        const queryParams = new URLSearchParams({from, to, clientId});
        return await RestUtil.get<RealizedReportRow[]>(`/report?${queryParams.toString()}`);
    }

    async getRealizedReportDetail(from: string, to: string, clientId: string) {
        const queryParams = new URLSearchParams({from, to, clientId});
        return await RestUtil.get<RealizedReportDetailRow[]>(`/report/detail?${queryParams.toString()}`);
    }

    getDeepOpportunity(){
        return RestUtil.get<Array<DeepCombo>>(`/options/deep`)
    }

    getInterest(){
        return RestUtil.get<Array<Combo>>(`/options/interest`)
    }

    feedBySellPrice(sellPrice:string){
        return RestUtil.get<Array<Feed>>(`/feed/sell/price/less/than/${sellPrice}/0`)
    }

    getAllExchanges(interestPerMonth:number){
        return RestUtil.get<Array<Exchange>>(`/exchanges/all/${interestPerMonth}`)
    }

    analyseMarket(){
        return RestUtil.get(`/analyse/market`)
    }

    getBrs(){
        return RestUtil.get<BRS>(`/brs`);
    }

    setBrs(val:boolean){
        return RestUtil.get<BRS>(`/brs/${val}`);
    }

    status(){
        return RestUtil.get<Array<Client>>(`/status`);
    }

    async kill() {
        return await RestUtil.get<string>(`/kill/all`);
    }

    getInfo() {
        return RestUtil.get<Info>("/info?domain=" + Config.BFF);
    }

     getSGBMarket() {
        return RestUtil.get<Array<SGBMarket>>('/market').then(sgbs => sgbs.map(modify))
            .catch(err => {
                console.log(err)
                return []
            });
    }

    bidBuy(tradingsymbol: string, exchange: string, price: number) {
        RestUtil.get(`/order/${exchange}/${tradingsymbol}/${price}`)
        Logger.info("BidBuy", {tradingSymbol : tradingsymbol, price : price })
    }

    buy(tradingsymbol: string, exchange: string, price: number) {
        RestUtil.get(`/order/ioc/${exchange}/${tradingsymbol}/${price}`)
        Logger.info("BidBuy", {tradingSymbol : tradingsymbol, price : price })
    }

    buyInst(genInfo: GenInfo, price: number, clientId: string) {
        RestUtil.get(`/client/${clientId}/buy_or_modify/${price}`)
        Logger.info("buy", {tradingSymbol : genInfo.tradingsymbol, price : price })
    }

    sellInst(genInfo: GenInfo, price: number, clientId: string) {
        RestUtil.get(`/client/${clientId}/sell_or_modify/${price}`)
        Logger.info("sell", {tradingSymbol : genInfo.tradingsymbol, price : price })
    }

    cancelOrders(tradingsymbol: string, exchange: string) {
        return RestUtil.get(`/cancel/order/${exchange}/${tradingsymbol}`);
    }

    setFocus(focus: boolean) {
        return RestUtil.get<Info>('/focus/'+focus);
    }

    setStepBack(stepBack: boolean) {
        return RestUtil.get<Info>('/stepback/'+stepBack);
    }

    sample() {
        return RestUtil.get<Info>('/sample');
    }

    getConfig() {
        return RestUtil.get<AppProperties>("/properties")
    }

    setConfig(congig:AppProperties) {
        return RestUtil.post("/properties", congig)
    }

    async getOptions() {
        return await RestUtil.get<OptionsMapping>('/options/all');
    }

    async getEquities() {
        return await RestUtil.get<Array<EquityMarket>>('/equity/all');
    }

    async getSellOrders(boughtAt: number, isin: string, interest: number, qty1: number) {
        return await RestUtil.get<Array<SellOrder>>(`/look/sell/exchange/${isin}/${boughtAt}/${qty1}/${interest}`)
    }

    async squareOff(symbol: string, clientId: string) {
        return await RestUtil.get(`/options/sqoff/${symbol}/${clientId}`)
    }

    async squeezer(clientId: string) {
        return await RestUtil.get<Array<SqueezeSell>>(`/options/positions/squeeze/${clientId}`)
    }

    async canExec() {
        return await RestUtil.get<Pair<string, boolean>>(`/options/orders/status/1`)
    }

    async getComboOrders(params: {
        clientId: string;
        chain: string;
        from?: number;
        to?: number;
        group: boolean;
        analyse: boolean;
        nonExpired: boolean;
    }) {
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                queryParams.append(key, String(value));
            }
        });
        return await RestUtil.get<Array<PlacedCombo>>(`/options/orders/combo?${queryParams.toString()}`);
    }

    async getOpportunityInstant(timestamp: number, name: string, expiry: number) {
        return await RestUtil.get<Array<Combo>>(`/options/opportunity/${timestamp}/${name}/${expiry}` )
    }

    async getLastOpportunities(): Promise<Array<Pair<number, ClientCombo>>> {
        return await RestUtil.get<Array<Pair<number, ClientCombo>>>(`/options/opportunity/last`)
    }

    async exec(combo: Combo, clientId?:string) {
        return await RestUtil.post(`/options/exec`, {
            type: combo.type,
            buyCall: combo.buyCall?.genInfo?.tradingsymbol,
            sellCall: combo.sellCall?.genInfo?.tradingsymbol,
            buyPut: combo.buyPut?.genInfo?.tradingsymbol,
            sellPut: combo.sellPut?.genInfo?.tradingsymbol,
            buyFut: combo.buyFut?.genInfo?.tradingsymbol,
            sellFut: combo.sellFut?.genInfo?.tradingsymbol,
            clientId: clientId,
            noMargin: combo.noMargin,
        })
    }

    async tryToWin(combo: Combo, clientId: string) {
        return await RestUtil.post<Pair<string, string>>(`/options/try_win/${clientId}`, {
            type: combo.type,
            buyCall: combo.buyCall?.genInfo?.tradingsymbol,
            sellCall: combo.sellCall?.genInfo?.tradingsymbol,
            buyPut: combo.buyPut?.genInfo?.tradingsymbol,
            sellPut: combo.sellPut?.genInfo?.tradingsymbol,
            buyFut: combo.buyFut?.genInfo?.tradingsymbol,
            sellFut: combo.sellFut?.genInfo?.tradingsymbol,
            noMargin: combo.noMargin,
        })
    }

    async margin(combo: Combo) {
        return await RestUtil.post<Charges>(`/options/margin`, {
            type: combo.type,
            buyCall: combo.buyCall?.genInfo?.tradingsymbol,
            sellCall: combo.sellCall?.genInfo?.tradingsymbol,
            buyPut: combo.buyPut?.genInfo?.tradingsymbol,
            sellPut: combo.sellPut?.genInfo?.tradingsymbol,
            buyFut: combo.buyFut?.genInfo?.tradingsymbol,
            sellFut: combo.sellFut?.genInfo?.tradingsymbol,
        })
    }

    async getMarginBySymbols({buyCall, sellCall, buyPut, sellPut, buyFut, sellFut, type}: {buyCall?: string, sellCall?: string, buyPut?: string, sellPut?: string, buyFut?: string, sellFut?: string, type: string}) {
        return await RestUtil.post<Charges>(`/options/margin`, {
            type: type,
            buyCall: buyCall,
            sellCall: sellCall,
            buyPut: buyPut,
            sellPut: sellPut,
            buyFut: buyFut,
            sellFut: sellFut,
        })
    }

    async getIntrinsicValues(symbols: string[]): Promise<{ [key: string]: number }> {
        return await RestUtil.post<{ [key: string]: number }>(`/options/symbols/intrinsic`, symbols);
    }

    async getMargin(token: number) {
        return await RestUtil.get<Charges>(`/options/margin/${token}`)
    }

    async getCombo(param: any, ignoreMargin:boolean) {
        let p:any = {}
        for (let i in param){
            if(param[i]!==""){
                p[i] = param[i]
            }
        }
        if(ignoreMargin) {
            p.noMargin = true
            return await RestUtil.post<Combo[]>(`/options/combo/fetch/sqOff`, p)
        }else return await RestUtil.post<Combo[]>(`/options/combo/fetch`, p)
    }

    async getCombos(option: String) {
        return await RestUtil.get<Combo[]>(`/options/combo/${option}`)
    }

    async getSqOffCombos() {
        return await RestUtil.get<ClientCombo[]>(`/options/sqoff/combos`);
    }

    async getClosings(symbol: string) {
        return await RestUtil.get<ClosingPrice[]>(`/equity/${symbol}`)
    }

    async deepAnalyse(client: string) {
        return await RestUtil.get<Array<FuturePositions>>(`/options/deep/analyse/${client}`)
    }

    async setAllowed(allowed:boolean) {
        return await RestUtil.get<Pair<string, boolean>>(`/options/orders/${allowed}`)
    }

    async checkStatus(clientId: string) {
        return await RestUtil.get<OptionStatus>(`/options/orders/status/${clientId}`)
    }

    async setMcxClient(client: string) {
        return await RestUtil.post(`/options/mcx_client/${client}`, "{}")
    }

    async setMCXMaster(client: string) {
        return await RestUtil.post(`/options/mcx_client_master/${client}`, "{}")
    }

    async getClients() {
        return await RestUtil.get<AppClients>(`/options/clients`)
    }

    async getAllClientBalance(): Promise<ClientBalance[]> {
      return await RestUtil.get<ClientBalance[]>("/options/clients/margin");
    }

    async getCutoffMargin(): Promise<Pair<string, number>> {
        return await RestUtil.get<Pair<string, number>>("/options/cutoff");
    }

    async updateCutoffMargin(cutOffInLacks: number): Promise<Pair<string, number>> {
        return await RestUtil.post<Pair<string, number>>(`/options/cutoff/${cutOffInLacks}`, "{}");
    }

    async addRemark(id: number, remarks: string) {
        return await RestUtil.post(`/options/remarks/${id}`, {remarks});
    }

    async getContractNoteByDate(clientId: string, date: string, isPreview: boolean) {
        if(isPreview) return await RestUtil.get<ContractNote>(`/contract/preview/${clientId}/${date}`);
        else return await RestUtil.get<ContractNote>(`/contract/fetch/${clientId}/${date}`);
    }

    async getContractNoteDates(clientId: string): Promise<string[]> {
        return await RestUtil.get<string[]>(`/contract/list/${clientId}`);
    }

    async generateContractNote(clientId: string, date: string) {
        return await RestUtil.get<string>(`/contract/persist/${clientId}/${date}`);
    }

    async getMcxDevolvement(clientId: string, date: string) {
        return await RestUtil.get<McxDevolvementResult>(`/contract/analyse/expiry/${clientId}/${date}`);
    }

    async getCarryForwardPositions(clientId: string, date: string) {
        return await RestUtil.get<ContractPosition[]>(`/contract/carry/${clientId}/${date}`);
    }

    async persistPositions() {
        return await RestUtil.get<string>(`/contract/persist/positions`);
    }

    async getClosingPricesByDate(date: string) {
        return await RestUtil.get<Closing[]>(`/contract/closing/${date}`);
    }

    async persistClosings(date: string) {
        return await RestUtil.post<string>(`/contract/closing/${date}`, '{}');
    }

    async updateClosings() {
        return await RestUtil.get<{ok: number}>(`/contract/closing/update`);
    }

    async getBonds() {
        return await RestUtil.get<Array<Bond>>(`/bonds/data`);
    }

    async getHighYieldBonds() {
        return await RestUtil.get<Array<Bond>>(`/bonds/high/yields`);
    }

    async getReport(clientId: string, fromDate?: string, toDate?: string, chain?: string, expiryDate?: string) {
        const queryParams = new URLSearchParams();
        if (fromDate) {
            queryParams.append("fromDate", fromDate);
        }
        if (toDate) {
            queryParams.append("toDate", toDate);
        }
        if (chain) {
            queryParams.append("chain", chain);
        }
        if (expiryDate) {
            queryParams.append("expiryDate", expiryDate);
        }
        const query = queryParams.toString();
        return await RestUtil.get<ReportResponse>(`/contract/report/${clientId}${query ? `?${query}` : ""}`);
    }

    async getUploadedReportRanges() {
        return await RestUtil.get<ClientReportRange[]>(`/contract/report`);
    }

    async uploadReport(clientId: string, files: File[]) {
        const formData = new FormData();
        files.forEach(file => formData.append("files", file, file.name));
        return await RestUtil.postForm<ReportUploadResponse>(`/contract/report2/${clientId}`, formData);
    }

    async getPushVapidKey(): Promise<string> {
        const data = await RestUtil.get<{ publicKey: string }>(`/communication/push/vapid-public-key`);
        return data.publicKey;
    }

    async subscribePush(subscription: PushSubscription): Promise<void> {
        await RestUtil.post(`/communication/push/subscribe`, subscription);
    }

    async unsubscribePush(endpoint: string): Promise<void> {
        await RestUtil.delete(`/communication/push/subscribe`, { endpoint });
    }

    goldPrice() {
        return RestUtil.get<Pair<string, number>>("/algo/goldPrice");
    }

    async getChurnerStatus() {
        return await RestUtil.get<FCStatus>(`/churner/status`);
    }

    async getChurnerOrderStatus() {
        return await RestUtil.get<String>(`/churner/order`);
    }

    async updateChurnerStatus(status: Partial<FCStatus>) {
        return await RestUtil.post<FCStatus>(`/churner/status`, status);
    }

    async getTodayTrades(clientId: string) {
        return await RestUtil.get<TodayTrades>(`/options/trades/client/${clientId}`);
    }

    async createCombo(clientId: string, tradeIds: string[]) {
        return await RestUtil.post<ComboOrder>(`/options/createCombo/clientId/${clientId}`, tradeIds);
    }
}

export default new GatewayService();

export function modify(market:SGBMarket) {
    market.maxBuyer = Math.max(market.maxBuyer, market.sgb.circuits.lowerCircuit)
    return market
}
